export const SliderEventType = {
  Change: 'change',
};

export default {
  SliderEventType,
};
